import { service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type { AtlasConfig, AtlasDisplay } from 'garaje/utils/atlas';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import urlBuilder from 'garaje/utils/url-builder';

interface AtlasEditorHeaderComponentProps {
  display: AtlasDisplay;
  config: AtlasConfig;
}

export default class AtlasEditorHeaderComponent extends Component<AtlasEditorHeaderComponentProps> {
  @service declare flashMessages: FlashMessagesService;
  @service declare ajax: AjaxFetchService;

  // Publish both the display and config changes to the Map Kiosk BFF
  // These changes propagate to the display in realtime
  publishTask = task({ drop: true }, async () => {
    try {
      await this.ajax.request(urlBuilder.mapi.studio.publishUrl(this.args.display.id), {
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          device: this.args.display,
          config: this.args.config,
        }),
      });

      this.flashMessages.showAndHideFlash('success', 'Published changes!');
    } catch (e) {
      const errorText = parseErrorForDisplay(e);
      this.flashMessages.showFlash('error', errorText);
    }
  });
}
